import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Wrapper from '../wrapper'
import License from './License'
import Typography from '@material-ui/core/Typography'
import { ButtonContained } from '../app-button/button'
import Checkbox from '@material-ui/core/Checkbox'

const styles = theme => ({
  paymentBox: {
    maxWidth: 380,
    marginLeft: 48,
    padding: '16px 32px',
    borderRadius: 8,
    position: 'relative',
  },
  paymentTitle: {
    marginBottom: 24,
    fontFamily: 'Roboto',
    fontSize: 8,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 2,
    letterSpacing: 2,
    color: 'rgba(0, 0, 0, 0.5)',
    textTransform: 'uppercase',
  },
  paymentSubTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  paymentContent: {
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  paymentInfoList: {
    listStyleType: 'none',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: 'rgba(0, 0, 0, 0.65)',
    '& li': {
      marginBottom: 16,
    },
    '& a': {
      pointerEvents: 'none',
      cursor: 'default',
      color: '#006fff',
      textDecoration: 'underline',
    },
  },
  paymentNext: {
    display: 'block',
    whiteSpace: 'pre-line',
  },
  paymentStatistics: {
    display: 'block',
  },
  paymentOffer: {
    display: 'flex',
    marginBottom: 24,
    marginLeft: '-15px',
  },
  paymentOfferLink: {
    color: '#000000',
    textDecoration: 'underline',
  },
  addBtnCard: {
    width: '100%',
    height: 40,
    padding: 0,
    fontSize: 16,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'rgb(0, 0, 0)',
  },
  disabled: {
    color: 'red',
  },
})

class AddPaymentCard extends Component {
  state = {
    isAgree: false,
    license: window.state.license,
    nextPayment: window.state.nextPayment,
  }

  handleChange = event => {
    this.setState({
      isAgree: event.target.checked,
    })
  }

  render() {
    const { classes } = this.props
    const {
      license,
      nextPayment: { date, amount },
    } = this.state

    return (
      <Wrapper shadow={1} className={classes.paymentBox}>
        <header className={classes.paymentTitle}>Платежи</header>
        <h2 className={classes.paymentSubTitle}>Добавьте платежную карту</h2>
        <section className={classes.paymentContent}>
          <p>Вы сможете отменить подписку и удалить карту в любой момент.</p>

          <p>
            При удалении карты во время платного периода вы сможете использовать
            систему в полном объеме, пока не наступит время следующего платежа.
          </p>
          <License license={license} />

          <ul className={classes.paymentInfoList}>
            <li>
              <span
                className={classes.paymentNext}
              >{`Следующий платеж:\n ${date}`}</span>
              <span>{`Сумма следующего платежа - ${amount} руб.`}</span>
            </li>
          </ul>

          <div className={classes.paymentOffer}>
            <Checkbox
              checked={this.state.isAgree}
              color="secondary"
              onChange={this.handleChange}
            />
            <Typography component="p" variant="body1">
              Я согласен с условиями{' '}
              <a
                href="/recurring.pdf?26022020"
                className={classes.paymentOfferLink}
              >
                “Оферты регулярных платежей”
              </a>
            </Typography>
          </div>
          <ButtonContained
            customClass={classes.addBtnCard}
            color="primary"
            text="Добавить карту"
            disabled={this.state.isAgree ? false : true}
            href="/card/add"
          />
        </section>
      </Wrapper>
    )
  }
}

export default withStyles(styles)(AddPaymentCard)
